
import { Vue, Component } from 'vue-property-decorator'
import User from '@/types/user'
import UserEditDetailsTab from '@/views/user/tabs/edit/UserEditDetailsTab.vue'
import UserEditRolesPermissionsTab from '@/views/user/tabs/edit/UserEditRolesPermissionsTab.vue'
import ActivityLogTable from '@/components/ActivityLogTable.vue'
import UserEditActivityTab from '@/views/user/tabs/edit/UserEditActivityTab.vue'
import UserRelatedProjects from '@/views/user/tabs/UserRelatedProjects.vue'
import ls from '@/ls'
import { can } from '@/globalFunctions'

@Component({
  methods: { can },
  components: { UserRelatedProjects, UserEditActivityTab, ActivityLogTable, UserEditRolesPermissionsTab, UserEditDetailsTab }
})

export default class UserEdit extends Vue {
  settings = {
    routeNames: { list: 'users', show: 'userShow', edit: 'userEdit' },
    routeParamKey: 'userId',
    functionNames: { setCurrent: 'setCurrentUser', clearCurrent: 'clearCurrentUser', save: 'saveUser' },
    getterNames: { current: 'currentUser', loading: 'loadingUser' }
  }

  currentTab:string = ls.get('userEditActiveTab') || 'details'

  mounted () : void {
    this.$store.dispatch(this.settings.functionNames.setCurrent, this.$route.params[this.settings.routeParamKey])
  }

  destroyed () : void {
    this.$store.dispatch(this.settings.functionNames.clearCurrent)
  }

  save () : void {
    this.$store.dispatch(this.settings.functionNames.save, this.currentItem)
  }

  setActiveTab (tab:string) : void {
    ls.set('userEditActiveTab', tab)
    this.currentTab = tab
  }

  navigateTo (routeName:string, id:number|undefined) : void {
    if (id) {
      this.$router.push({ name: routeName, params: { [this.settings.routeParamKey]: id.toString() } })
    } else {
      this.$router.push({ name: routeName })
    }
  }

  previousPage () : void {
    this.$router.go(-1)
  }

  get currentItem () : User {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }

  get navigationCollapsed () : boolean {
    return this.$store.getters.navigationCollapsed
  }

  get screenWidth () : number {
    return screen.width
  }
}
